import { combineReducers } from 'redux'
import { fetchBootstrapAsync } from 'shared/store/actions/bootstrap'

import { createReducer } from 'typesafe-actions'

const bootstrapStatus = createReducer<null | string>(null).handleAction(
  [
    fetchBootstrapAsync.success,
    fetchBootstrapAsync.request,
    fetchBootstrapAsync.cancel,
    fetchBootstrapAsync.failure,
  ],
  (_, action) => action.type
)

export default combineReducers({ bootstrapStatus })
